module.exports = __webpack_public_path__ + "img/map.aafaee1f.jpg";